import React from "react";

const PrivacyPolicy = () => (
  <main className="section-padding max-w-3xl mx-auto">
    <h1 className="text-3xl font-serif font-bold mb-6 text-gold">Privacy Policy</h1>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">1. Information We Collect</h2>
      <p>We collect information you provide when booking, contacting us, or using our website. This may include your name, contact details, and trip information.</p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">2. Use of Information</h2>
      <p>Your information is used to provide and improve our services, process bookings, and communicate with you. We do not sell or share your information with third parties except as required by law.</p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">3. Data Security</h2>
      <p>We implement reasonable security measures to protect your information. However, no method of transmission over the Internet is 100% secure.</p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">4. Cookies</h2>
      <p>Our website may use cookies to enhance your experience. You can disable cookies in your browser settings, but some features may not function properly.</p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">5. Third-Party Links</h2>
      <p>Our website may contain links to third-party sites. We are not responsible for the privacy practices or content of those sites.</p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-semibold mb-2">6. Changes to Policy</h2>
      <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.</p>
    </section>
    <section>
      <h2 className="text-xl font-semibold mb-2">7. Contact</h2>
      <p>If you have questions about this Privacy Policy, contact us at <a href="mailto:info@imslimoandchaufferservice.com" className="text-gold underline">info@imslimoandchaufferservice.com</a>.</p>
    </section>
  </main>
);

export default PrivacyPolicy;
